import { useState } from "react";
import { Bell, Check } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { useStore } from "../context/StoreContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StockAlert = ({ productId, compact = false }) => {
  const { t } = useStore();
  const ta = t.stockAlert;
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await axios.post(`${API}/stock-alerts`, { email, product_id: productId });
      setDone(true);
      toast.success(r.data.already ? ta.already : ta.success);
    } catch { toast.error(ta.error); }
    finally { setBusy(false); }
  };

  if (done) {
    return (
      <p className={`flex items-center gap-2 text-[#4A624E] ${compact ? "text-xs" : "text-sm"}`} data-testid={`stock-alert-done-${productId}`}>
        <Check size={14} /> {ta.success}
      </p>
    );
  }
  return (
    <form onSubmit={submit} className={`flex gap-2 ${compact ? "" : "max-w-md"}`} data-testid={`stock-alert-form-${productId}`}>
      <input
        data-testid={`stock-alert-email-${productId}`}
        type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
        placeholder={ta.placeholder}
        className={`flex-1 min-w-0 rounded-full border border-stone-300 bg-white px-4 text-sm text-stone-900 placeholder:text-stone-400 focus:outline-none focus:border-[#C85A32] transition-colors ${compact ? "py-2" : "py-3"}`}
      />
      <button
        data-testid={`stock-alert-submit-${productId}`}
        type="submit" disabled={busy}
        className={`inline-flex items-center gap-2 rounded-full bg-stone-900 text-white text-[11px] uppercase tracking-[0.15em] hover:bg-[#C85A32] transition-colors disabled:opacity-60 ${compact ? "px-4 py-2" : "px-5 py-3"}`}
      >
        <Bell size={13} /> {busy ? "..." : ta.cta}
      </button>
    </form>
  );
};
